<template>  
    <div>
		<!-- 是否开始上班 -->
		<confirm-modal v-if="isWork" :firmTitle="firmTitle" :firmLeft="firmLeft" :firmRight="firmRight"
		    @leftClick="onCloseModalClick" @rightClick="startWork">
		</confirm-modal>
		
		<!-- 上班成功弹框 -->
		<toast-modal :isToast="isToast" :ToastText="ToastText"></toast-modal>
		<div class="user-info">
			<div class="logo-work">
				<div class="logo"></div>
				<div class="work" :class='work=="已下班"?"grey-g":""'  @click="working">{{work}}</div>
			</div>
			<p class="text">{{userInfo.user_name||"用户名称"}}</p>
		</div>
       
        <div class="my-wallet" @click="navigateTo('./wallet-sale')">
			<span class="wallet-logo wallet"></span>
			<div class="wallet-name">我的钱包</div>
		</div>

		<div class="my-wallet" @click="manage">
			<span class="bank-logo wallet"></span>
			<div class="wallet-name">银行卡管理</div>
		</div>
		
		<div class="my-wallet">
			<span class="notice-logo wallet"></span>
			<div class="notice-wrap">
				<span class="notice-on">公众号服务通知</span>
				<span class="notice" @click="switchNotice" :class='noticeFlag?"on":"off"'></span>
			</div>
		</div>
    </div>
</template>

<script>
    import CommonHeader from '@/components/CommonHeader'
	import ConfirmModal from '@/components/ConfirmModal'
	import ToastModal from '@/components/ToastModal'
    import utils from '@/assets/jslibs/utils'
    import {getUserInfo,WechatParLogin} from '@/api/common'
	import {WechatNotice,getWork} from '@/api/personal'
    export default {
        name: 'index',
		data(){
			return{
				isWork:false,
				firmTitle:"是否开始上班",
				firmLeft:"取消",
				firmRight:"确认",
				userInfo:{},
				work:"下班",
				noticeFlag:false,
				ToastText:"",
				isToast:false,
				isMobile:utils.isMobile(),
			}
		},
        components: {
            CommonHeader,
			ConfirmModal,
			ToastModal
        },
		
		beforeCreate(){
			sessionStorage.removeItem("roleType");
		},
        
        created() {
			this.getUserInfo()
        },
        
        mounted(){
            document.title = "个人中心"
        },
        
        methods: {
			//获取用户信息
			async getUserInfo(){
			    const { data, status } = await getUserInfo();
			    if (status !== 200) return 
			    this.userInfo = data
				if(this.userInfo.is_wechat_notice == "1"){///不接受微信通知
					this.noticeFlag = false
				}else{
					this.noticeFlag = true
				}
				
				if(this.userInfo.is_work == "1"){//上班
					this.work = "已上班"
				}else{
					this.work = "已下班"
				}
			},
			
			working(){
				this.isWork =true;
				if(this.work=="已下班"){
					this.firmTitle = "是否开始上班";
				}else{
					this.firmTitle = "是否开始下班";
				}
			},
			
			// 上下班
			async startWork(){
				const { data, status } = await getWork();
				if (status !== 200) return
				this.isWork = false;
				this.isToast = true;
				this.work == "已下班"?this.ToastText = "已开始上班":this.ToastText = "已开始下班";
				this.getUserInfo();
				setTimeout(()=>{
					this.isToast = false;
				},1500)
			},
			
            navigateTo(path){
                this.$router.push(path)
            },
			
			async wechatParLogin(code){
			    let obj = {code:code}
			    const { status,data } = await WechatParLogin(obj);
			    if (status !== 200) return
			}, 
			
			async getWechatCode(){
			    const code = utils.getQueryString('code') // 截取路径中的code，如果没有就去微信授权，如果已经获取到了就直接传code给后台获取openId
			    const appId = "wxf3c9d00e530fedd8";
			    const url = window.location.href;
			    if (code == null || code === '') {
			        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appId + '&redirect_uri=' + encodeURIComponent(url) + '&response_type=code&scope=snsapi_base&state=1#wechat_redirect'
			    } else {
			        this.wechatParLogin(code) //把code传给后台获取用户信息
			    }
			},
			
			// 开启,关闭微信通知
			async WechatNotice(){
			    const { status,data } = await WechatNotice();
			    if (status !== 200) return
			    this.noticeFlag =!this.noticeFlag
			}, 
			
			switchNotice(){
			    if(this.isMobile==3){//微信浏览器
			        if(this.userInfo.open_id){//已授权
			            this.WechatNotice()
			        
			        }else{
			            this.getWechatCode()
			        }
			    }
			    
			    else{
			        window.toast("请到微信浏览器打开","txt");
			        return
			    }
			},
			onCloseModalClick(){
				this.isWork = false;
			},
			manage(){
				this.$router.push({path:'./bankcard-manage',query:{type:"manage"}})
			}
        },
    }
</script>

<style lang='less' scoped>
	@import '~@/assets/styles/variable.less';
	@import '~@/assets/styles/handleMethods.less';
	@import '~@/assets/styles/reset.css';

    section{font-family:PingFangSC-Regular;font-weight:500;background: #fff;padding-bottom: 50px}
	.user-info{margin-bottom: 20px;}
    .logo-work{position: relative}
	.logo{width: 60px;height: 60px;margin: 0 auto;margin-top: 36px;background: url(../assets/images/personal/pic_head_bg.png) no-repeat center center;background-size: cover}
	.user-icon{display: block;width: 60px;height: 60px;margin: 0 auto;margin-top: 36px;border-radius: 50%}
	.work{position: absolute;right: 0;top: 0.4rem;;width:68px;height:28px;line-height: 28px;background:rgba(255,134,48,1);border-radius:100px 0px 0px 100px;text-align: center;font-size:15px;font-family:PingFangSC-Semibold;font-weight:600;color:rgba(255,255,255,1);}
	.text{color:rgba(51,51,51,1);font-size: 17px;margin-top: 16px;text-align:center}
	.grey-g{background:#ccc;}
	.my-wallet{display: -webkit-box;display: -ms-flexbox;display: flex;padding-left:16px;height: 52px;line-height: 52px;align-items: center;}
	.wallet{margin-right: 20px;display: inline-block;width: 20px;height: 20px;}
	.wallet-logo{background: url(../assets/images/personal/ic_mine_money.png) no-repeat center center;background-size: cover;}
	.news-logo{background: url(../assets/images/personal/ic_mine_message.png) no-repeat center center;background-size: cover;}
	.bank-logo{background: url(../assets/images/personal/ic_mine_message.png) no-repeat center center;background-size: cover;}
	.notice-logo{background: url(../assets/images/personal/ic_mine_wechat.png) no-repeat center center;background-size: cover;}
	.wallet-name{color:rgba(51,51,51,1);font-size: 17px;flex: 1;border-bottom: 1px solid #EEEEEE;background: url(../assets/images/home/ic_home_enter.png) no-repeat 297px center;background-size: 8px;}
	.notice-wrap{color:rgba(51,51,51,1);font-size: 17px;flex: 1;border-bottom: 1px solid #EEEEEE;}
	.notice-on{display: inline-block;width: 232px;margin-right: 20px}
	.notice{width: 50px;height:52px;display: inline-block;vertical-align: middle;}
	.on{background: url(../assets/images/personal/pic_mine_on.png) no-repeat center center;background-size: 50px;}
	.off{background: url(../assets/images/personal/pic_mine_off.png) no-repeat center center;background-size: 50px;}
	


</style>
